import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=2f9f84cf&"
import script from "./StatsCard.vue?vue&type=script&lang=js&"
export * from "./StatsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9f84cf')) {
      api.createRecord('2f9f84cf', component.options)
    } else {
      api.reload('2f9f84cf', component.options)
    }
    module.hot.accept("./StatsCard.vue?vue&type=template&id=2f9f84cf&", function () {
      api.rerender('2f9f84cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatsCard.vue"
export default component.exports